import create from "zustand";

// define the store
export const appStore = create((set) => ({
  currentLeague: {},
  leagueName: "",
  currentSeason: 0,
  showBetSlip: false,
  countDownTimer: 60,
  liveWeekNumber: undefined,
  goalScored: {},
  betSlipSelections: [],
  calculatedBetSlip: {},
  currencyCode: "",
  sessionCurrencyCode: "",
  playerBalance: 0,
  selectedBetWeek: 0,
  betSlipDetails: {
    _id: "",
    betId: "",
    betType: "",
    fkLeagueId: "",
    fkSeasonId: "",
    fkWeekId: "",
    fkCountryId: "",
    stake: 0,
    status: "DRAFT",
    selections: [],
  },
  bonusConfig: [],
  generalConfig: {},
  operatorId: "",
  betPlacedSelections: [],
  playerId: "",
  leaguesList: [],
  queryUrlData:{},
  setLeaguesList: (league) => {
    set((state) => ({
      leaguesList: [...league],
    }));
  },
  setPlayerId: (Id) => {
    set((state) => ({
      playerId: Id,
    }));
  },
  setCurrencyCode: (currencyCode) => {
    set((state) => ({
      currencyCode: currencyCode,
    }));
  },
  setSessionCurrencyCode: (sessionCurrency) => {
    set((state) => ({
      sessionCurrencyCode: sessionCurrency,
    }));
  },
  setPlayerBalance: (playerBalance) => {
    set((state) => ({
      playerBalance: playerBalance,
    }));
  },
  setCurrentLeague: (league) => {
    set((state) => ({
      currentLeague: { ...league },
    }));
  },
  setLeagueName: (leagueName) => {
    set((state) => ({
      leagueName: leagueName
    }));
  },
  setCurrentSeason: (season) => {
    set((state) => ({
      currentSeason: season,
    }));
  },
  setShowBetSlip: (showBetSlip) => {
    set((state) => ({
      showBetSlip: showBetSlip,
    }));
  },
  setLiveWeekNumber: (liveWeekNumber) => {
    set((state) => ({
      liveWeekNumber: liveWeekNumber,
    }));
  },
  setCountDownTimer: (time) => {
    set((state) => ({
      countDownTimer: time,
    }));
  },
  setGoalScored: (data) => {
    set((state) => ({
      goalScored: data,
    }));
  },
  setBetSlipSelections: (selections) => {
    set((state) => ({
      betSlipSelections: [...selections],
    }));
  },
  setCalculatedBetSlip: (calculatedBetSlip) => {
    set((state) => ({
      calculatedBetSlip: { ...calculatedBetSlip },
    }));
  },
  setSelectedBetWeek: (selectedBetWeek) => {
    set((state) => ({
      selectedBetWeek: selectedBetWeek,
    }));
  },
  setBetSlipDetails: (betSlipDetails) => {
    set((state) => ({
      betSlipDetails: betSlipDetails,
    }));
  },
  setBonusConfig: (bonus) => {
    set((state) => ({
      bonusConfig: [...bonus],
    }));
  },
  setGeneralConfig: (generalConfig) => {
    set((state) => ({
      generalConfig: { ...generalConfig },
    }));
  },
  setOperatorId: (operatorId) => {
    set((state) => ({
      operatorId: operatorId,
    }));
  },
  setBetPlacedSelections: (placedSelecion) => {
    set((state) => ({
      betPlacedSelections: [...placedSelecion],
    }));
  },
  setQueryUrlData: (obj) => {
    set((state) => ({
      queryUrlData: obj,
    }));
  },
}));
